import {Component, Input} from '@angular/core';
import {ColumnFilter, DataTableColumnData, DataTableConfig, DataTableObservableDataSource, Organisation, TableAction} from '@cas-hub/acabim-common-client';
import {CurrentResourceUsage} from '../../../../_models/resource-subscription.model';
import {ResourceSubscriptionService} from '../../../../_services/resource-subscription.service';

@Component({
    selector: 'acabim-admin-resource-subscriptions-view',
    templateUrl: './resource-subscriptions-view.component.html',
    styleUrls: ['./resource-subscriptions-view.component.scss']
})
export class ResourceSubscriptionsViewComponent extends DataTableObservableDataSource<CurrentResourceUsage> {

    @Input() public set selectedOrganisation(val: Organisation | undefined) {
        this._selectedOrganisation = val;
        if (val) {
            this.onRequestToRefreshData();
        }
    }

    public get selectedOrganisation(): Organisation | undefined {
        return this._selectedOrganisation;
    }

    public readonly actions: TableAction[] = [];
    public columnFilters: ColumnFilter[] = [];

    public readonly columnData: DataTableColumnData[] = [
        {displayName: 'ResourceType', objectPropertyName: 'resourceType'},
        {displayName: 'Upper Limit', objectPropertyName: 'allowedResources'},
        {displayName: 'Used', objectPropertyName: 'usedResources'}
    ];

    public readonly config: DataTableConfig = {
        globalFilterFields: [],
        hasActions: false,
        hasCheckbox: false,
        hasDetailsButton: false,
        hasFilters: false,
        isExportEnabled: false,
        isLazyLoadingEnabled: false,
        isPaginationEnabled: false,
        isSearchEnabled: false,
        searchPlaceHolder: '',
        tableHeading: 'Resource subscriptions'
    };

    private _selectedOrganisation?: Organisation;

    public constructor(private readonly resourceSubscriptionService: ResourceSubscriptionService) {
        super(() => {
            if (this.selectedOrganisation) {
                return this.resourceSubscriptionService.getCurrentUsage(this.selectedOrganisation.id);
            }

            return null;
        });
    }

    public onAction(action: TableAction): void {
    }

    public onDataExpanded(value: CurrentResourceUsage): void {
    }

    public onDataFiltered(): void {
    }
}
